import { Amplify } from 'aws-amplify';
import configuration from './aws-exports';
console.log(
  "Amplify Configuration is ",
  configuration,
  JSON.stringify(configuration)
);
Amplify.configure(configuration);
